module.exports = __webpack_public_path__ + "img/bte.75a1933f.png";